module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_4.9836f28d.png";